import { FC, useEffect } from 'react';
import { useModalContext } from 'store/modal';
import { UpdateFeatureFlagsModal } from 'containers/feature-flags';

const KEYWORD = 'mmeellpp';

export const FeatureFlagsListener: FC = () => {
  const { openModal } = useModalContext();

  useEffect(() => {
    let buffer = '';

    const onEvent = (event: KeyboardEvent) => {
      buffer = `${buffer}${event.key}`.slice(-KEYWORD.length);

      if (buffer === KEYWORD) {
        openModal({
          component: UpdateFeatureFlagsModal,
        });
      }
    };

    window.addEventListener('keyup', onEvent);

    return () => {
      window.removeEventListener('keyup', onEvent);
    };
  }, [openModal]);

  return null;
};
